<template>
  <section>
    <div class="container">

      <div class="hero is-bold">
        <div class="hero-body" style="padding-left: 0px; padding-top: 0px">
          <div class="container">
            <h1 class="title" style="color:#3e8ed0">Playlists storage</h1>
            <h4 class="subtitle">Manage the storage for your playlists here.</h4>
          </div>
        </div>
      </div>
<div class="columns is-multiline is-mobile">
        <div class="column is-9 is-offset-1 box" border-color="black">
          <div><b>Playlists storage size: </b>{{ !totalPlaylistsSize ? (totalPlaylistsSize === 0 ? formatBytes(totalPlaylistsSize, 2) : 'Calculating...') : formatBytes(totalPlaylistsSize, 2)}}</div>
                              <b-progress
            :rounded=0
            :value="playlistPercent"
            type="is-primary"
            format="percent"
            show-value
        ></b-progress>

        <div><b>Total storage used: </b>{{ !totalStorageSize ? (totalStorageSize === 0 ? formatBytes(totalStorageSize, 2) : 'Calculating...') : formatBytes(totalStorageSize, 2) + '/1 GB'}}</div>
                              <b-progress
            :rounded="false"
            :value="totalPercentUsed"
            type="is-primary"
            format="percent"
            show-value
        ></b-progress>
        <!-- <div><b>Total storage free: </b>{{formatBytes(freeStorageSize, 2)}}/1 GB</div>
<b-progress
            :rounded="false"
            :value="totalPercentFree"
            type="is-success"
            format="percent"
            show-value
        ></b-progress> -->
          </div>
                  <div></div>
</div>
      <div class="columns is-multiline is-mobile">
        <div class="column is-4 is-offset-1 box" border-color="black" v-for="(playlist, playlistId) in playlists" :key="playlistId">
          <div class="level" >
            <div class="level-left">
              <div style="font-size:17.5px;color:#3e8ed0" class="level-item"><b>{{showName(playlist.name)}}</b></div>
            </div>
            <div class="level-right">
              <div class="level-item" v-if="playlist.items && playlist.items.filter(x => x.resourceName !== '' && x.resourceName !== undefined).length > 0">
                <b-button type="is-primary is-light" @click="seeResources(playlistId, playlist.name)">See resources</b-button>
              </div>
              <div class="level-item" v-else>
                <b-button type="is-primary is-light" @click="seeResources(playlistId, playlist.name)" disabled>See resources</b-button>
              </div>
              </div>
          </div>

            <!-- <p>Number of resources: {{playlist.items ? playlist.items.filter(x => x.resourceName !== '').length : 'N/A'}}</p> -->
            <p><b>No. of resources: </b>{{numPlRes[playlistId] !== undefined ? numPlRes[playlistId] : 'Calculating...'}}</p>
            <p><b>Total size:</b> {{totalSizes.find(x => x.key === playlistId) !== undefined ? formatBytes(totalSizes.find(x => x.key === playlistId).value, 2) : 'Calculating...'}}</p>
        </div>
        <div></div>

                <div class="column is-4 is-offset-1 box" border-color="black">
          <div class="level" >
            <div class="level-left">
              <b-button type="is-ghost" icon-left="trash" style="cursor:auto"></b-button>
              <div style="font-size:17.5px;color:#3e8ed0" class="level-item"><b>Playlists archive</b></div>
            </div>
            <div class="level-right">
              <div class="level-item" v-if="shouldSeeResources">
                <b-button type="is-primary" @click="seeArchivedResources()">See resources</b-button>
              </div>
              <div class="level-item" v-else>
                <b-button type="is-primary" @click="seeArchivedResources()" disabled>See resources</b-button>
              </div>
              </div>
          </div>

            <p><b>No. of resources: </b>{{!noArchived ? (noArchived === 0 ? noArchived : 'Calculating...') : noArchived}}</p>
            <p><b>Total size: </b>{{!totalSizeArchived ? (totalSizeArchived === 0 ? formatBytes(totalSizeArchived, 2) : 'Calculating...') : formatBytes(totalSizeArchived, 2)}}</p>
        </div>
        <div></div>
      </div>

    </div>
  </section>
</template>

<script>
import PlaylistsResources from '@/components/storage/playlists/PlaylistsResources'
import PlaylistsArchive from '@/components/storage/playlists/PlaylistsArchive'

export default {
  name: 'PlaylistsStorage',
  data: () => {
    return {
      loadingComponent: null,
      noArchived: null,
      totalSizeArchived: null,
      totalSizes: [],
      totalPlaylistsSize: null,
      totalStorageSize: null,
      // freeStorageSize: null,
      totalPercentUsed: null,
      // totalPercentFree: null,
      playlistPercent: null,
      shouldSeeResources: false,
      numPlRes: []
    }
  },
  computed: {
    playlists () {
      return this.$store.state.playlists
    },
    menus () {
      return this.$store.state.menus
    },
    specialOffers () {
      return this.$store.state.specialOffers
    },
    /* playlistsArchive () {
      return this.$store.state.playlistsArchive
    }, */
    menusArchive () {
      return this.$store.state.menusArchive
    },
    specialOffersArchive () {
      return this.$store.state.specialOffersArchive
    },
    workspaceId () {
      return this.$store.state.workspaceId
    }
  },
  mounted: function () {
    this.globalLogger('mounted')
    // var x = Number.isNan(7)
    // this.globalLogger('nan', x)
    this.loadArchiveData()
  },
  methods: {
    seeResources (id, name) {
      this.$buefy.modal.open({
        parent: this,
        component: PlaylistsResources,
        props: { playlistId: id, playlistName: name },
        hasModalCard: true,
        trapFocus: true,
        onCancel: this.cancelAdd
      })
    },
    seeArchivedResources () {
      const modal = this.$buefy.modal.open({
        parent: this,
        component: PlaylistsArchive,
        hasModalCard: true,
        trapFocus: true,
        onCancel: this.cancelAdd,
        canCancel: ['x']
      })
      modal.$on('close', () => {
        this.showStorageData()
      })
    },
    formatBytes (bytes, decimals) {
      if (bytes === 0) {
        return '0 B'
      }
      const k = 1024
      const dm = decimals < 0 ? 0 : decimals
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
      const i = Math.floor(Math.log(bytes) / Math.log(k))
      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
    },
    loadArchiveData () {
      let database = this.$store.state.database
      let store = this.$store
      if (!this.getNotMigrated().includes(store.state.uid)) {
        database.ref('/neoslide/archive/' + this.workspaceId + '/menus/').on('value', (snapshot) => {
          store.commit('setMenusArchive', snapshot.val())
        })
        database.ref('/neoslide/archive/' + this.workspaceId + '/playlists/').on('value', (snapshot) => {
          store.commit('setPlaylistsArchive', snapshot.val())
        })
        database.ref('/neoslide/archive/' + this.workspaceId + '/specialOffers/').on('value', (snapshot) => {
          store.commit('setSpecialOffersArchive', snapshot.val())
          this.showStorageData()
        })
      } else {
        this.globalLogger('doesnt include')
        database.ref('/archive/' + store.state.uid + '/menus/').on('value', (snapshot) => {
          store.commit('setMenusArchive', snapshot.val())
        })
        database.ref('/archive/' + store.state.uid + '/playlists/').on('value', (snapshot) => {
          store.commit('setPlaylistsArchive', snapshot.val())
        })
        database.ref('/archive/' + store.state.uid + '/specialOffers/').on('value', (snapshot) => {
          store.commit('setSpecialOffersArchive', snapshot.val())
          this.showStorageData()
        })
      }
    },
    showStorageData () {
      this.globalLogger('show storage data')
      var playlistsArchive = this.$store.state.playlistsArchive
      this.totalSizes = []
      this.totalStorageSize = 0
      this.totalSizeArchived = 0
      this.totalPlaylistsSize = 0
      this.noArchived = 0
      // this.loadingComponent = this.$buefy.loading.open()
      /* if (this.playlists === undefined) {
        this.loadingComponent.close()
      } */
      for (let playlist in this.playlists) {
        var sum = 0
        var playlistRef = Object.assign({}, this.$store.getters.getPlaylist(playlist))
        if (playlistRef.items !== undefined) {
          var playlistItems = [...playlistRef.items.filter(x => x.resourceName !== '' && x.resourceName !== undefined)]
          // this.globalLogger('playlist items unfiltered: ', playlistItems)
          playlistItems = playlistItems.filter((v, i, a) => a.findIndex(v2 => (v2.resourceName === v.resourceName)) === i)
          // this.globalLogger('playlist items filtered: ', playlistItems)
          var noResources = playlistItems.length
          this.numPlRes[playlist] = noResources
          // this.numbersRes[playlist] = noResources
          if (noResources > 0) {
            for (let i = 0; i < playlistItems.length; i++) {
              if (playlistItems[i].resourceName !== '') {
                sum += playlistItems[i].resourceSize
              }
            }
            this.totalSizes.push({ 'key': playlist, 'value': sum })
            this.totalStorageSize += sum
          } else {
            this.numPlRes[playlist] = 0
            this.totalSizes.push({ 'key': playlist, 'value': 0 })
          }
          // this.totalPlaylistsSize
        } else {
          this.globalLogger('heree!')
          this.numPlRes[playlist] = 0
          this.totalSizes.push({ 'key': playlist, 'value': 0 })
        }
      }
      if (this.totalSizes.length > 0) {
        for (let j = 0; j < this.totalSizes.length; j++) {
          this.totalPlaylistsSize += this.totalSizes[j].value
        }
      }
      // archive begin
      if (playlistsArchive !== null) {
        for (let i = 0; i < playlistsArchive.items.length; i++) {
          // this.globalLogger('pl: ', playlistsArchive.items[i])
          this.totalStorageSize += playlistsArchive.items[i].resSize
          this.totalPlaylistsSize += playlistsArchive.items[i].resSize
          this.totalSizeArchived += playlistsArchive.items[i].resSize
          this.noArchived++
        }
      }
      if (this.noArchived > 0) {
        this.shouldSeeResources = true
      } else {
        this.shouldSeeResources = false
      }
      if (this.menusArchive !== null) {
        for (let x = 0; x < this.menusArchive.items.length; x++) {
          this.totalStorageSize += this.menusArchive.items[x].resSize
        }
      }
      if (this.specialOffersArchive !== null) {
        for (let y = 0; y < this.specialOffersArchive.items.length; y++) {
          this.totalStorageSize += this.specialOffersArchive.items[y].resSize
        }
      }
      // archive end
      this.playlistPercent = (this.totalPlaylistsSize / 1073741824) * 100
      for (let menu in this.menus) {
        var sum1 = 0
        var menuRef = Object.assign({}, this.$store.getters.getMenu(menu))
        if (menuRef.items !== undefined) {
          var menuItems = [...menuRef.items.filter(x => x.resourceName !== '' && x.resourceName !== undefined)]
          menuItems = menuItems.filter((v, i, a) => a.findIndex(v2 => (v2.resourceName === v.resourceName)) === i)
          var noResources1 = menuItems.length
          // this.numbersRes[playlist] = noResources
          if (noResources1 > 0) {
            for (let i = 0; i < menuItems.length; i++) {
              if (menuItems[i].resourceName !== '') {
                sum1 += menuItems[i].resourceSize
              }
            }
            this.totalStorageSize += sum1
          }
        }
      }
      for (let offer in this.specialOffers) {
        var sum2 = 0
        var offerRef = Object.assign({}, this.$store.getters.getSpecialOffer(offer))
        if (offerRef.items !== undefined) {
          var offerItems = [...offerRef.items.filter(x => x.resourceName !== '' && x.resourceName !== undefined)]
          offerItems = offerItems.filter((v, i, a) => a.findIndex(v2 => (v2.resourceName === v.resourceName)) === i)
          var noResources2 = offerItems.length
          // this.numbersRes[playlist] = noResources
          if (noResources2 > 0) {
            for (let i = 0; i < offerItems.length; i++) {
              if (offerItems[i].resourceName !== '') {
                sum2 += offerItems[i].resourceSize
              }
            }
            this.totalStorageSize += sum2
          }
        }
      }
      this.totalPercentUsed = (this.totalStorageSize / 1073741824) * 100
    },
    showName (name) {
      if (name.length > 21) {
        return name.substr(0, 21) + '...'
      }
      return name
    }
  }
}
</script>

<style scoped>
  .box {
    border: 0.5px solid rgb(212, 212, 212);
  }
</style>



// WEBPACK FOOTER //
// src/components/storage/playlists/PlaylistsStorage.vue